import React from 'react';
import PropTypes from 'prop-types';
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import OrderItemsReadOnlyColumn from "../../shared/component/dataTable/columns/OrderItemsReadOnlyColumn.json";
import MemberSectionPanel from "../../shared/component/MemberSectionPanel";
import {MemberOrderSummaryFields} from "./OrderDetailFields";
import MemberOrderActionFooter from "../order/MemberOrderActionFooter";
import "../../module/order/orderCheckoutActions.css";
import "../../module/order/myOrders.css";

const defaultOrder = {
    id: null,
    orderNo: null,
    orderDate: null,
    basketStatus: null,
    syncStatus: null,
    orderStatus: null,
    acceptedDate: null,
    preparingDate: null,
    readyDate: null,
    deliveredDate: null,
    totalPrice: null,
    orderType: null,
    errorType: "INIT",
    errorMessage: null,
    basketDetailList: []
};

export default class ItemsDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: defaultOrder,
            pageMode: null
        };
    }

    render() {
        return (
            <div className="order-detail-dialog__content member-order-detail member-order-detail--sticky-footer member-order-detail--dialog">
                <div className="member-order-detail__scroll">
                    <MemberSectionPanel title="Order Summary" sectionId="order-detail-summary">
                        <MemberOrderSummaryFields
                            order={this.state.order}
                            showPrices={true}
                            showTradingName={true}
                            showPaymentType={true}
                        />
                    </MemberSectionPanel>

                    <MemberSectionPanel title="Items" sectionId="order-detail-items">
                        <DataTableWithButton
                            data={this.state.order.basketDetailList}
                            className="order-detail-items-table checkout-order-table"
                            ref={(elem) => {
                                this.refDataTable = elem;
                            }}
                            selectionMode="single"
                            paginator={false}
                            fields={OrderItemsReadOnlyColumn.fields}
                        />
                    </MemberSectionPanel>
                </div>

                <MemberOrderActionFooter
                    actions={[
                        {
                            key: 'close',
                            label: 'Close',
                            icon: 'close',
                            onClick: () => this.props.closeDisplayDialog(),
                            className: 'member-order-action-btn--primary member-order-action-btn--solo',
                        },
                    ]}
                />
            </div>
        );
    }

    setData = (data) => {
        this.setState({order: data});
    };

    clearData = () => {
        const obj = Object.assign({}, defaultOrder);
        this.setState({order: obj});
    };
}

ItemsDetail.propTypes = {
    order: PropTypes.object,
    closeDisplayDialog: PropTypes.func,
};
